import React from 'react';
import styled from 'styled-components';
import { AppColors } from 'helpers';
import { HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { Image } from 'components/common/vendors/Image';
import { TextDisplay } from 'vendor-deprecated/Text';
import { dateUtil } from 'helpers/dateUtils';
import { useAppSetting } from 'helpers/useAppSetting';
import { Hr } from 'vendor-deprecated/CommonParts';

//CHAPTER MENU
const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  flex: 1;
  padding-bottom: 20px;
  cursor: pointer;
  position: relative;
`;

const ThumbnailWrapper = styled.div<{ width?: string }>`
  width: ${(props) => props.width || '150px'};
  cursor: pointer;
  background-size: cover;
  overflow: hidden;
  border-radius: 4px;
  transition: all 0.5s;
  object-fit: cover;
  -webkit-transform: scale(1);
  transform: scale(1);
`;

const TitleWrapper = styled.div<{ size?: string }>`
  font-weight: 600;
  font-size: ${(props) => props.size || '24px'};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface RecentNewsCardProps {
  title?: string;
  time?: string;
  image?: string;
  onClick: () => void;
}

export const RecentNewsCard = (props: RecentNewsCardProps) => {
  const { appSize } = useAppSetting();

  return (
    <CardWrapper
      onClick={(e) => {
        e.preventDefault();
        props.onClick();
      }}
    >
      <HorizontalView fullWidth flexWrap={'nowrap'} alignContent={'topLeft'} paddingBottom={'20px'}>
        <ThumbnailWrapper width={'80px'}>
          <Image src={props.image} objectFit={'cover'} width={'100%'} />
        </ThumbnailWrapper>
        <VerticalView
          width={'calc(100% - 80px)'}
          alignContent={'centerLeft'}
          paddingLeft={'20px'}
          paddingRight={'20px'}
        >
          <TitleWrapper size={appSize.h4}>{props.title}</TitleWrapper>

          <HorizontalView fullWidth alignContent={'centerLeft'}>
            <TextDisplay size={appSize.h5} color={AppColors.DARK}>
              {dateUtil.dateFormat(props.time || '', 'MMM D, YYYY')}
            </TextDisplay>
          </HorizontalView>
        </VerticalView>
      </HorizontalView>

      <Hr />
    </CardWrapper>
  );
};
